const cancelationReason = {
  ratingCriteria: 'Rating Criteria',
  addRatingCriteria: 'Add Rating Criteria',
  editRatingCriteria: 'Edit Rating Criteria',
};
export default cancelationReason;
